import {useEffect, useState} from 'react'

import clsx from 'clsx'
import useMutationApi from '../../../../../../hooks/useMutation'
import {LoadingSpinner} from '../../../../../../_ePulse/layout/components/LoadingSpinner'
import {ToastMessageContainer} from '../../../../../../_ePulse/layout/components/ToastMessageContainer'
import {TestType} from '../types/testType'
import useLazyQueryApi from '../../../../../../hooks/useLazyQuery'
import useApi from '../../../../../../hooks/useQuery'
import {
  ADD_NEW_TEST_GROUP,
  ADD_TEST_GROUP,
  DELETE_TEST_GROUP,
  GET_ASSOCIATED_TEST_GROUPS,
  GET_LAB_ROOM_LIST,
  GET_MULTIPLE_TEST_NAME_BY_PRODUCT,
  GET_SELECTED_PRODUCTS,
} from '../../../GraphQLQueries/ProductOffering'
import {toast} from 'react-toastify'
import {AddLabModal} from './labModal'
import {useNavigate} from 'react-router-dom'
import '../../../../../../App.css';

const SelectProduct = (props: any) => {
  const navigate = useNavigate()
  const [modalShow, setModalShow] = useState(0)
  const [labRooms, setLabRooms] = useState<any[]>([])
  const [field, setfield] = useState<any>(null) // Selected Product
  const [productList, setProductList] = useState<any>([]) // Get Product
  const [testGroupList, setTestGroupList] = useState<any>([])
  const [filteredProductList, setFilteredProductList] = useState<any[]>([]) 
  const [associatedTestList, setAssociatedTestList] = useState<any>([]) // Get Associated Tests with Test Group
  const [isTabMenu, setIsTabMenu] = useState(true)
  const [currentTest, setCurrentTest] = useState<any>(null)
  const [showLabModal, setShowLabModal] = useState(false)
  const [selectedTestGroup, setSelectedTestGroup] = useState<any>(null) // Selected Test Group for Edit/Delete
  // Current Text for Edit/Delete

  const {
    loading: loadingData,
    error: MedicineError,
    data: productData,
    refetch: refetchList,
  } = useApi('', GET_SELECTED_PRODUCTS, {})

  const {
    loading: loadingProducts,
    error: productError,
    data: products,
    fetchData: refetchData,
  } = useLazyQueryApi('', GET_ASSOCIATED_TEST_GROUPS)

  const {
    loading: loadingAssociatedTest,
    error: associatedTestError,
    data: associatedTestData,
    fetchData: refetchAssociatedTestData,
  } = useLazyQueryApi('', GET_MULTIPLE_TEST_NAME_BY_PRODUCT)
  const {loading: LabLoading, error: labError, data: labData} = useApi('', GET_LAB_ROOM_LIST, {})

  const {createData, loading, error, data} = useMutationApi(ADD_NEW_TEST_GROUP)

  useEffect(() => {
    if (labData) {
      console.log(labData)
      setLabRooms(labData.getAllLabRooms)
    }
  }, [labData])

  useEffect(() => {
    console.log('productData', productData)
    if (productData && productData.getBusinessProductOffering) {
      setProductList(productData.getBusinessProductOffering)

      // setfield(productData.getBusinessProductOffering[0]);
    }
  }, [productData])

useEffect(() => {
  if (!labRooms.length || !productList.length) return

  const labRoomTypes = new Set(labRooms.map((room) => room.roomType))

  const filtered = productList.filter((product: any) =>
    labRoomTypes.has(product.productValue)
  )

  setFilteredProductList(filtered)
}, [labRooms, productList])

  useEffect(() => {
    console.log('product', products)
    if (products && products.getBusinessProductGroupByProductOffering) {
      setTestGroupList(products.getBusinessProductGroupByProductOffering)
    }
  }, [products])

  useEffect(() => {
    if (associatedTestData && associatedTestData.getBusinessTestByMutlipleTestGroup.length > 0) {
      const testGroupName = associatedTestData.getBusinessTestByMutlipleTestGroup[0].id // Assuming the first group is the one you want
      const associatedTests: TestType[] =
        associatedTestData.getBusinessTestByMutlipleTestGroup[0].testNames.map((test: any) => ({
          id: test.testId,
          productName: test.testName,
          testGroupName: testGroupName,
          testName: test.testName,
          testCost: test.price,
          testCode: test.testCode,
          isDelete: test.isDeleted,
          groupName: test.groupName,
          testGroupId: test.testGroupId[0],
          isBusinessCreated: test.isBusinessCreated || false, // Assuming this field exists in the test data
        }))

      setAssociatedTestList(associatedTests)
    } else {
      setAssociatedTestList([])
    }
  }, [associatedTestData])

  const [activeKey, setActiveKey] = useState<any>(null)

  const handleSelect = (eventKey: any) => {
    console.log('eventKey', eventKey)
    const testGroupValue = testGroupList.find((i: any) => i.id === eventKey)?.testGroupValue
    console.log('testGroupName', testGroupValue)
    if (eventKey !== null && testGroupValue) {
      setActiveKey(eventKey) // Set the loadingId to the selected eventKey
      refetchAssociatedTestData({productGroup: [testGroupValue]})
    }
    setActiveKey(eventKey)
  }

  return (
    <div className='d-flex flex-column form-wrapper'>
      <LoadingSpinner isLoading={loadingData || loading || loadingProducts} />
      <div>
        <ToastMessageContainer />
      </div>
      <AddLabModal
        modalState={showLabModal}
        closeModal={() => setShowLabModal(false)}
        onCancel={() => setShowLabModal(false)}
        onDone={() => {
          setShowLabModal(false)
          navigate('/scancenter/labs')
        }}
      />
      <div className='d-flex justify-content-between align-items-center'>
        <h2 className='page-title'>Product</h2>
      </div>
      <div className='d-flex'>
        {filteredProductList.length > 0 && field ? (
          <button
            key={field.id}
            className='tab active'
            style={{
              margin: '10px',
              color: '#fff',
              textAlign: 'center',
              padding: '10px 90px',
              border: 'none',
              fontWeight: 'bold',
              backgroundColor: '#bdbdbd',
            }}
            onClick={() => {
              // Optionally allow deselect or do nothing
            }}
          >
            {field.productName}
          </button>
        ) : (
          filteredProductList.map((tab: any) => (
            <button
              key={tab.id}
              className={`tab ${field?.productValue === tab.productValue ? 'active' : ''}`}
              style={{
                margin: '10px',
                color: '#000',
                textAlign: 'center',
                padding: '10px 90px',
                border: 'none',
                // fontWeight: 'bold',
                backgroundColor: '#BDBDBD',
              }}
              onClick={() => {
                // console.log('labRooms----->> ', labRooms)

                console.log('tab', tab)
                const avaliableRoom = labRooms.filter(
                  (room: any) => room.roomType === tab.productValue
                )
                if (avaliableRoom.length > 0) {
                  console.log('avaliableRoom', avaliableRoom, tab)
                  setfield(tab)
                  props.setProduct(tab)
                  refetchData({productValue: tab.productValue})
                } else {
                  console.log('avaliableRoom', avaliableRoom)
                  console.log('false')
                  setShowLabModal(true)
                  //  toast.warning(`${tab.productName} - No Lab Room`)
                }
              }}
            >
              {tab.productName}
            </button>
          ))
        )}
      </div>
      <hr />

      {testGroupList.length > 0 && field && (
        <div className='vertical-tabs'>
          <div
            className={clsx(
              isTabMenu ? 'tab-list-container col-3' : 'tab-list-container col-2 menuOpen'
            )}
          >
            <div className='tab-list' style={{height: '400px', overflow: 'hidden auto'}}>
              {testGroupList.length > 0 ? (
                testGroupList.map((tab: any) => {
                  return (
                    <div className='d-flex align-items-center' key={tab.id}>
                      <button
                        key={tab.id}
                        className={`tab ${
                          selectedTestGroup?.testGroupLabel === tab.testGroupLabel ? 'active' : ''
                        }`}
                        style={{width: '100%'}}
                        onClick={() => {
                          setSelectedTestGroup(tab)
                          handleSelect(tab.id)
                        }}
                      >
                        {tab.testGroupLabel}
                      </button>
                    </div>
                  )
                })
              ) : (
                <div>No Test Group Added</div>
              )}
            </div>
          </div>
          <div className='tab-content'>
            {associatedTestList.length > 0 ? (
              <>
                {loadingAssociatedTest ? (
                  'Loading...'
                ) : associatedTestList.length === 0 ? (
                  <>
                    <div>No associated tests found.</div>
                    <div
                      onClick={() => {
                        setModalShow(2)
                      }}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: 'blue',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                      }}
                    >
                      Add Test
                    </div>
                  </>
                ) : (
                  <>
                    {/* <TestTable data={associatedTestList} testGroupValue={selectedTestGroup.testGroupValue} testGroupLabel={selectedTestGroup.testGroupLabel} /> */}
                    {/* <div className='align-items-center  p-3' onClick={() => { setModalShow(2) }} style={{ background: 'none', border: 'none', color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}>
                            Add Test
                          </div> */}
                    {associatedTestList.length > 0 && (
                      <div className='mt-3'>
                        {/* Select All Button */}
                        <div className='mb-2 d-flex justify-content-end'>
                          <button
                            className='ePulse-btn-selected-white ePulse-btn-selected-white:hover'
                            onClick={() => {
                              const allSelected = associatedTestList.every((test: any) =>
                                props.selectedTests?.some((t: any) => t.id === test.id)
                              )
                              if (allSelected) {
                                // Deselect all
                                if (props.onTestSelect) {
                                  associatedTestList.forEach((test: any) => {
                                    if (props.selectedTests?.some((t: any) => t.id === test.id)) {
                                      props.onTestSelect(test)
                                    }
                                  })
                                }
                              } else {
                                // Select all
                                if (props.onTestSelect) {
                                  associatedTestList.forEach((test: any) => {
                                    if (!props.selectedTests?.some((t: any) => t.id === test.id)) {
                                      props.onTestSelect(test)
                                    }
                                  })
                                }
                              }
                            }}
                          >
                            {associatedTestList.every((test: any) =>
                              props.selectedTests?.some((t: any) => t.id === test.id)
                            )
                              ? 'Deselect All'
                              : 'Select All'}
                          </button>
                        </div>
                        {/* Test List */}
                        <div>
                          {associatedTestList.map((test: any) => {
                            const isChecked = props.selectedTests?.some(
                              (t: any) => t.id === test.id
                            )
                            return (
                              <div
                                key={test.id}
                                className='p-2 mb-2 border rounded d-flex align-items-center  justify-content-between'
                                style={{background: '#f8f9fa', cursor: 'pointer'}}
                              >
                                <span>{test.testName}</span>
                                <input
                                  type='checkbox'
                                  checked={!!isChecked}
                                  onChange={() => {
                                    if (props.onTestSelect) props.onTestSelect(test)
                                  }}
                                  style={{marginRight: 8}}
                                />
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            ) : (
              <div>No associated tests found</div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default SelectProduct
